import React from "react";
import { Contribution } from "../../components/User/Contribution";
import Layout from "./Layout";

export const ContributionPage = () => <Layout><Contribution /></Layout> 